import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { sliderView } from '../../utils/slider';
import { printGroupLog } from '../../utils';
import { get } from '../../utils/data';

interface ResponseBody {
  message: 'success' | 'error';
  description?: string;
  data: {
    error_code: number;
    description: string;
    log_id: string;
    idv_decision_conf?: string;
    [key: string]: any;
  };
}

function parseResponse(config: AxiosRequestConfig): ResponseBody {
  let resp: ResponseBody = config?.data?.data?.response || config?.data || {};
  if (typeof resp === 'string') {
    try {
      resp = JSON.parse(resp);
    } catch (error) {
      console.log('fetch', error);
    }
  }
  return resp;
}

export const after = (res: AxiosResponse) => {
  const url = res?.config?.url || '';
  const logid = res?.headers?.['x-tt-logid'] || '';
  const idvDecisionConf = res?.headers?.['x-tt-verify-idv-decision-conf'] || '';
  const resp: any = parseResponse(res);
  const initProps = get('initProps');
  const printLog = initProps?.printLog || false;

  // success
  if (resp?.message === 'success') {
    if (printLog) {
      printGroupLog(
        `call ${url} result >>>>`,
        {
          SUCCESS: resp.data,
          Logid: logid,
        },
        false
      );
    }
    return Promise.resolve(resp.data);
  }

  // fail
  if (printLog) {
    printGroupLog(
      `call ${url} result >>>>`,
      {
        ERROR: resp.data,
        Logid: logid,
      },
      false
    );
  }

  // slider
  const ifShowCaptcha = !initProps?.appShowCaptcha;
  const sliderDecisionConfig = resp?.data?.verify_center_decision_conf;
  if (ifShowCaptcha && sliderDecisionConfig) {
    return Promise.resolve(
      sliderView.show({
        verifyData: sliderDecisionConfig,
        requestConfig: res?.config,
      })
    );
  }
  return Promise.reject({
    ...resp.data,
    log_id: logid,
    idv_decision_conf: idvDecisionConf,
  });
};
